document.addEventListener('DOMContentLoaded', function () {
    const radioInput = document.getElementById('delivery_strategies-PICK_UP');
    const cityBlock = document.getElementById('TextField33-label').parentNode().parentNode();

    console.log(cityBlock);
    console.log(radioInput.checked);

    function toggleCityBlock() {
        if (radioInput.checked) {
            // Приховати блок та зняти обов'язковість
            if (cityBlock) {
                cityBlock.style.display = 'none';
                const inputField = cityBlock.querySelector('input[name="city"]');
                if (inputField) {
                    inputField.required = false; // Знімаємо обов'язковість
                }
            }
        } else {
            // Відновити блок та знову зробити обов'язковим
            if (cityBlock) {
                cityBlock.style.display = 'block';
                const inputField = cityBlock.querySelector('input[name="city"]');
                if (inputField) {
                    inputField.required = true; // Знову робимо обов'язковим
                }
            }
        }
    }

    radioInput.addEventListener('change', toggleCityBlock);
    toggleCityBlock();
});
